import { handleService } from './common'

const prefixapi = '/api/File'
const prefixupload = '/upload/File'

const url = {
  upload: prefixapi + '/Save',
  UploadFile: prefixupload + '/UploadFile'
}
export default {
  // 文件上传
  upload (data) {
    // let url = "/upload/File/Save";
    return handleService(url.upload, data, 'POST')
  },
  // 版本上传专业上传接口
  UploadFile (data) {
    // let url = "/api/File/UploadFile";
    return handleService(url.UploadFile, data, 'POST')
  }
}
